/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { Settings, UpdatedSettings, DAY_OF_WEEK } from "./types";

function getNextDayOfTheWeek(dayName = DAY_OF_WEEK.MON) {
  const dayOfWeek = Object.values(DAY_OF_WEEK).indexOf(dayName);

  return dayjs().startOf("week").add(dayOfWeek, "day").add(1, "week").valueOf();
}

function isDiff(
  prevSetting: Settings[number],
  nextSetting: UpdatedSettings[number]
) {
  if (prevSetting.status !== nextSetting.status) {
    return true;
  }

  for (const nextParam of nextSetting.parameters ?? []) {
    const parameter = prevSetting.parameters.find(
      (prevParam) => prevParam.id === nextParam.id
    );

    if (parameter == null) {
      return true;
    }

    if (nextParam.value !== `${parameter.value}`) {
      return true;
    }
  }

  return false;
}

export function returnDiff(
  prevSettings: Settings,
  nextSettings: UpdatedSettings
) {
  return nextSettings.filter((nextSetting) => {
    const setting = prevSettings.find(
      (prevSetting) => nextSetting.id === prevSetting.id
    );

    if (setting != null) {
      return isDiff(setting, nextSetting);
    }

    return false;
  });
}

const CLOUD_WASTE_ITEM = "WasteSettingsLastChange";

export function setLastChangeInfo() {
  const lastChangesTimestamp = Date.now();
  const nextDay = getNextDayOfTheWeek(DAY_OF_WEEK.MON) || 0;

  localStorage.setItem(
    CLOUD_WASTE_ITEM,
    JSON.stringify({
      lastChanges: lastChangesTimestamp,
      recalculationTime: nextDay,
    })
  );
}

export function isSettingsRecalculated() {
  const wasteSettingsLastChange = localStorage.getItem(CLOUD_WASTE_ITEM);
  if (wasteSettingsLastChange) {
    const diff =
      JSON.parse(wasteSettingsLastChange).recalculationTime - Date.now();
    return diff > 0;
  }

  return false;
}
